import { __decorate, __awaiter } from 'tslib';
import { BaseService, DocumentValidator, PartnerIndustriesService, PasswordValidator, ErrorMessageService, UiBsUtilModule } from '@wlp/ui-bs-util';
import { FormControl, Validators, FormBuilder } from '@angular/forms';
import { ConfigService, SpeViewNVouncherClubNscProxy, SpeNVouncherClubNscProxy, SpeNUserAccountProxy, SpeViewNUserAccountProxy, SpeNAccountsProxy, SpeViewNAccountProxy, UiPxNscModule } from '@wlp/ui-px-nsc';
import { Injectable, NgModule } from '@angular/core';
import { Storage } from '@ionic/storage';
import { map } from 'rxjs/operators';
import { SpeNAccountsProxy as SpeNAccountsProxy$1, UiPxCashInModule } from '@wlp/ui-px-cashin';
import { UiBsTranslateModule } from '@wlp/ui-bs-translate';

class NscRegisterResponse {
}

class NscSignupResponse {
}

class NscPremiumBasicInfoResponse {
}

class NscPremiumPaymentPlanResponse {
}

class NscIndicatePartnerRequest {
}

class NscIndicatePartnerResponse {
}

var BenefitEnum;
(function (BenefitEnum) {
    BenefitEnum["BENEFIT"] = "BENEFIT";
    BenefitEnum["NO_BENEFIT"] = "NO_BENEFIT";
})(BenefitEnum || (BenefitEnum = {}));

var AddressType;
(function (AddressType) {
    AddressType["PHYSIC"] = "fisico";
    AddressType["SITE"] = "online";
})(AddressType || (AddressType = {}));

var TransactionType;
(function (TransactionType) {
    TransactionType["DEBIT"] = "DEBIT";
    TransactionType["CREDIT"] = "CREDIT";
})(TransactionType || (TransactionType = {}));

var QrcodeType;
(function (QrcodeType) {
    QrcodeType["NSC"] = "CLUBE_NSC";
})(QrcodeType || (QrcodeType = {}));

var StatusQrcode;
(function (StatusQrcode) {
    StatusQrcode["PAID_OUT"] = "PAID_OUT";
    StatusQrcode["NOT_PAY"] = "NOT_PAY";
})(StatusQrcode || (StatusQrcode = {}));

var OrderStatusEnum;
(function (OrderStatusEnum) {
    OrderStatusEnum["PENDING"] = "PENDING";
    OrderStatusEnum["WAITING_PROCESSING"] = "WAITING_PROCESSING";
    OrderStatusEnum["PROCESSING"] = "PROCESSING";
    OrderStatusEnum["AUTHORIZED"] = "AUTHORIZED";
    OrderStatusEnum["NOT_AUTHORIZED"] = "NOT_AUTHORIZED";
    OrderStatusEnum["SCHEDULED"] = "SCHEDULED";
})(OrderStatusEnum || (OrderStatusEnum = {}));

let PartnerIndustryService = class PartnerIndustryService extends BaseService {
    constructor(formBuilder, storage, configService, partnerIndustriesService) {
        super(storage, configService);
        this.formBuilder = formBuilder;
        this.storage = storage;
        this.configService = configService;
        this.partnerIndustriesService = partnerIndustriesService;
        this.errorPartnerIndustryErrorMessage = {
            partnerCnpj: [{ type: 'required', message: 'NSC.INDICATE_NSC.MESSAGE.REQUIRED' }],
            fantasyName: [{ type: 'required', message: 'NSC.INDICATE_NSC.MESSAGE.REQUIRED' }],
            email: [{ type: 'required', message: 'NSC.INDICATE_NSC.MESSAGE.REQUIRED' }],
            cellphone: [{ type: 'required', message: 'NSC.INDICATE_NSC.MESSAGE.REQUIRED' }],
            industry: [{ type: 'required', message: 'NSC.INDICATE_NSC.MESSAGE.REQUIRED' }],
        };
    }
    getFormPartnerIndustry() {
        this.formPartnerIndustryInfo = this.formBuilder.group({
            partnerCnpj: new FormControl('', Validators.compose([Validators.required, DocumentValidator.isValidCNPJ])),
            fantasyName: new FormControl('', Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(100)])),
            email: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(6),
                Validators.maxLength(60),
                Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,5}'),
            ])),
            cellphone: new FormControl('', Validators.compose([Validators.required, Validators.minLength(10), Validators.maxLength(14)])),
            industry: new FormControl('', Validators.compose([Validators.required])),
        });
        return this.formPartnerIndustryInfo;
    }
    getFormErrorPartnerIndustryErrorMessage() {
        return this.errorPartnerIndustryErrorMessage;
    }
    getIndustries() {
        return this.partnerIndustriesService.getListIndustries();
    }
};
PartnerIndustryService.ctorParameters = () => [
    { type: FormBuilder },
    { type: Storage },
    { type: ConfigService },
    { type: PartnerIndustriesService }
];
PartnerIndustryService = __decorate([
    Injectable()
], PartnerIndustryService);

let CategoryService = class CategoryService {
    constructor(service) {
        this.service = service;
    }
    getAllCategories() {
        return this.service.getAllCategories();
    }
};
CategoryService.ctorParameters = () => [
    { type: SpeViewNVouncherClubNscProxy }
];
CategoryService = __decorate([
    Injectable()
], CategoryService);

let DashboardService = class DashboardService {
    constructor(service) {
        this.service = service;
    }
    getAllBanners() {
        return this.service.getBanners();
    }
};
DashboardService.ctorParameters = () => [
    { type: SpeViewNVouncherClubNscProxy }
];
DashboardService = __decorate([
    Injectable()
], DashboardService);

let CardService = class CardService {
    constructor(service) {
        this.service = service;
    }
    /**
     * busca os cards por meio de um filtro e limite de cards
     * @param filter
     * @param limit
     * @returns Observable<NscCard>
     */
    getAllCard(filter, limit, sort) {
        const sortOption = sort || false;
        return this.service.findCards(filter, limit, sortOption);
    }
    /**
     * busca um card por meio de um filtro e limite de cards
     * @param filter
     * @param limit
     * @returns Observable<NscCard>
     */
    getOneCard(filter, limit) {
        return this.service.findCard(filter, limit);
    }
    /**
     * busca os cards em destaques
     * @param filter
     * @param limit
     * @returns Observable<NscCard>
     */
    findHighlightsCards(filter, limit) {
        return this.service.findHighlightsCards(filter, limit);
    }
    /**
     * busca os cards acontecendo dos proximos dias
     * @returns Observable<NscCardResult>
     */
    findEventCards(filter, limit) {
        return this.service.findEventCards(filter, limit);
    }
};
CardService.ctorParameters = () => [
    { type: SpeViewNVouncherClubNscProxy }
];
CardService = __decorate([
    Injectable()
], CardService);

let CouponService = class CouponService {
    constructor(serviceView, service) {
        this.serviceView = serviceView;
        this.service = service;
    }
    /**
     * busca os cards em destaques
     * @param filter
     * @param limit
     * @returns Observable<NscCard>
     */
    findUsageLocations(filter, limit) {
        return this.serviceView.findUsageLocations(filter, limit);
    }
    /**
   * busca branchs de locais de uso por _id
   * @param filter
   * @returns Observable<NscCouponUsage>
   */
    findBranchs(filter) {
        return this.serviceView.findBranchs(filter);
    }
    /**
     * criar um coupon
     * @param request
     * @returns
     */
    createCoupon(request) {
        return this.service.createCoupon(request);
    }
    /**
     * busca o coupon por id do usuario
     * @param userUuid
     * @returns
     */
    findCouponByUser(userUuid) {
        return this.serviceView.findCouponByUser(userUuid);
    }
    /**
     * busca o coupon pelo seu id
     * @param couponUuuid
     * @returns
     */
    findCoupon(couponUuuid) {
        return this.serviceView.findCoupon(couponUuuid);
    }
};
CouponService.ctorParameters = () => [
    { type: SpeViewNVouncherClubNscProxy },
    { type: SpeNVouncherClubNscProxy }
];
CouponService = __decorate([
    Injectable()
], CouponService);

const STORAGE_USER_ID_KEY = 'NSC_USER_KEY';
let SignUpService = class SignUpService extends BaseService {
    constructor(formBuilder, storage, configService, serviceAccount, serviceAccountView) {
        super(storage, configService);
        this.formBuilder = formBuilder;
        this.storage = storage;
        this.configService = configService;
        this.serviceAccount = serviceAccount;
        this.serviceAccountView = serviceAccountView;
        this.errorMessagesLogin = {
            email: [
                { type: 'required', message: 'NSC.LOGIN.LOGIN_EMAIL.REQUIRED' },
                // {
                //     type: 'minlength',
                //     message: 'NSC.LOGIN.LOGIN_EMAIL.MIN_CHAR',
                //     param: { minLength: 6 },
                // },
                // {
                //     type: 'maxlength',
                //     message: 'NSC.LOGIN.LOGIN_EMAIL.MAX_LENGTH',
                //     param: { maxLength: 60 },
                // },
                { type: 'pattern', message: 'NSC.LOGIN.LOGIN_EMAIL.PARTTNER' },
            ],
            password: [
                {
                    type: 'required',
                    message: 'NSC.LOGIN.LOGIN_PASSWORD.REQUIRED',
                },
            ],
        };
        this.errorMessagesRegister = {
            fullName: [
                { type: 'required', message: 'NSC.REGISTER.NAME.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'NSC.REGISTER.NAME.MIN_CHAR',
                    param: { minLength: 6 },
                },
                {
                    type: 'maxlength',
                    message: 'NSC.REGISTER.NAME.MAX_LENGTH',
                    param: { maxLength: 100 },
                },
            ],
            email: [
                { type: 'required', message: 'NSC.REGISTER.EMAIL.REQUIRED' },
                { type: 'already', message: 'NSC.REGISTER.EMAIL.ALREADY_USED' },
                // {
                //     type: 'minlength',
                //     message: 'NSC.REGISTER.EMAIL.MIN_LENGTH',
                //     param: { minLength: 6 },
                // },
                // {
                //     type: 'maxlength',
                //     message: 'NSC.REGISTER.EMAIL.MAX_LENGTH',
                //     param: { maxLength: 60 },
                // },
                { type: 'pattern', message: 'NSC.REGISTER.EMAIL.PARTTNER' },
            ],
            password: [
                {
                    type: 'required',
                    message: 'NSC.REGISTER.PASSWORD.MESSAGE.REQUIRED',
                },
                {
                    type: 'minlength',
                    message: 'NSC.REGISTER.PASSWORD.MESSAGE.MIN_CHAR',
                    param: {
                        minLength: 6,
                    },
                },
                {
                    type: 'maxlength',
                    message: 'NSC.REGISTER.PASSWORD.MESSAGE.MAX_LENGTH',
                    param: {
                        maxLength: 16,
                    },
                },
                {
                    type: 'pattern',
                    message: 'NSC.LOGIN.LOGIN_PASSWORD.MIN_CHAR',
                    param: {
                        minChar: 6,
                    },
                },
                {
                    type: 'equality',
                    message: 'NSC.REGISTER.CONFIRMPASSWORD.EQUALITY',
                },
            ],
            confirmPassword: [
                { type: 'required', message: 'NSC.REGISTER.CONFIRMPASSWORD.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'NSC.REGISTER.CONFIRMPASSWORD.MIN_CHAR',
                    param: {
                        minLength: 6,
                    },
                },
                {
                    type: 'maxlength',
                    message: 'NSC.REGISTER.CONFIRMPASSWORD.MAX_LENGTH',
                    param: {
                        maxLength: 16,
                    },
                },
                {
                    type: 'pattern',
                    message: 'NSC.LOGIN.LOGIN_PASSWORD.MIN_CHAR',
                    param: {
                        minChar: 6,
                    },
                },
                {
                    type: 'equality',
                    message: 'NSC.REGISTER.CONFIRMPASSWORD.EQUALITY',
                },
            ],
        };
    }
    getFormNscRegister() {
        this.formNscSignup = this.formBuilder.group({
            fullName: new FormControl('', Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(100)])),
            email: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(6),
                Validators.maxLength(60),
                Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
            ])),
            password: new FormControl('', Validators.compose([
                Validators.required,
                PasswordValidator.hasEmptySpace,
                Validators.minLength(6),
                Validators.maxLength(100),
                Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,}$'),
            ])),
            confirmPassword: new FormControl('', Validators.compose([
                Validators.required,
                PasswordValidator.hasEmptySpace,
                Validators.minLength(6),
                Validators.maxLength(100),
                Validators.pattern('^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,}$'),
            ])),
        });
        return this.formNscSignup;
    }
    getFormMessageLogin() {
        return this.errorMessagesLogin;
    }
    getFormMessageRegister() {
        return this.errorMessagesRegister;
    }
    getFormNscLogin() {
        this.formNscLogin = this.formBuilder.group({
            email: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(6),
                Validators.maxLength(60),
                Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,5}'),
            ])),
            password: new FormControl('', Validators.compose([
                Validators.required,
                PasswordValidator.hasEmptySpace,
                Validators.minLength(6),
                Validators.maxLength(100),
            ])),
        });
        return this.formNscLogin;
    }
    /**
     *
     * Metodos de gerenciamento dos usuarios!
     */
    /**
     * insere um novo usuario a base (dados basicos)
     * @param user
     */
    insertUser(user) {
        this.storage.remove(STORAGE_USER_ID_KEY); // limpa o storage!
        return this.serviceAccount.insertData(user).pipe(map((user) => {
            if (user !== null && user !== undefined) {
                // console.log(user._id);
                this.storage.set(STORAGE_USER_ID_KEY, user._id);
                return user;
            }
        }));
    }
    /**
     * atualiza o usuario na base
     * @param user
     */
    updateUser(user) {
        return this.serviceAccount.updateData(user);
    }
    /**
     * pega os dados do usuario pelo id
     * @param id
     */
    getUser(id) {
        return this.serviceAccountView.getUserData(id);
    }
    /**
     * busca o id do usuario (enquanto esta cadastrando)
     */
    getCurrentUserId() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.storage.get(STORAGE_USER_ID_KEY);
        });
    }
    getUserDataByWlpAndPayment(wlpUuid, paymentUuid) {
        return this.serviceAccountView.getUserDataByWlpAndPayment(wlpUuid, paymentUuid);
    }
    checkUserEmail(uuidWhiteLabel, email) {
        return this.serviceAccountView.checkUserEmail(uuidWhiteLabel, email);
    }
    findDocumentIsUsed(uuidWhiteLabel, verify) {
        return this.serviceAccountView.findDocumentIsUsed(uuidWhiteLabel, verify);
    }
};
SignUpService.ctorParameters = () => [
    { type: FormBuilder },
    { type: Storage },
    { type: ConfigService },
    { type: SpeNUserAccountProxy },
    { type: SpeViewNUserAccountProxy }
];
SignUpService = __decorate([
    Injectable()
], SignUpService);

let PremiumInfosService = class PremiumInfosService extends BaseService {
    constructor(formBuilder, storage, configService) {
        super(storage, configService);
        this.formBuilder = formBuilder;
        this.storage = storage;
        this.configService = configService;
        this.errorBasicInfoErrorMessage = {
            fullName: [{ type: 'required', message: 'NSC.PREMIUM_NSC.BASIC_INFO_NSC.MESSAGE.REQUIRED' }],
            email: [{ type: 'required', message: 'NSC.PREMIUM_NSC.BASIC_INFO_NSC.MESSAGE.REQUIRED' }],
            bornDate: [{ type: 'required', message: 'NSC.PREMIUM_NSC.BASIC_INFO_NSC.MESSAGE.REQUIRED' }],
            phone: [
                { type: 'required', message: 'NSC.PREMIUM_NSC.BASIC_INFO_NSC.MESSAGE.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'NSC.PREMIUM_NSC.BASIC_INFO_NSC.MESSAGE.MIN_CHAR',
                    param: {
                        minLength: 13,
                    },
                },
            ],
            document: [
                { type: 'required', message: 'NSC.PREMIUM_NSC.BASIC_INFO_NSC.MESSAGE.REQUIRED' },
                {
                    type: 'cpfNotValid',
                    message: 'NSC.PREMIUM_NSC.BASIC_INFO_NSC.MESSAGE.DOCUMENT'
                },
                {
                    type: 'alreadyUsed',
                    message: 'NSC.PREMIUM_NSC.BASIC_INFO_NSC.MESSAGE.DOCUMENT_USED'
                },
            ],
        };
        this.planPaymentInfoErrorMessage = {
            cardNumber: [
                { type: 'required', message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.CARD_NUMBER.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.CARD_NUMBER.MIN_LENGTH',
                    param: {
                        minLength: 16,
                    },
                },
                {
                    type: 'maxlength',
                    message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.CARD_NUMBER.MAX_LENGTH',
                    param: {
                        maxLength: 16,
                    },
                },
            ],
            cardName: [
                { type: 'required', message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.CARRIERS_NAME.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.CARRIERS_NAME.MIN_LENGTH',
                    param: {
                        minLength: 6,
                    },
                },
                {
                    type: 'maxlength',
                    message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.CARRIERS_NAME.MAX_LENGTH',
                    param: {
                        maxLength: 60,
                    },
                },
            ],
            validDate: [
                { type: 'required', message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.VALID_THRU.REQUIRED' },
                { type: 'validThru', message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.VALID_THRU.VALIDTHRU' },
                {
                    type: 'minlength',
                    message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.VALID_THRU.MIN_LENGTH',
                    param: {
                        minLength: 4,
                    },
                },
                {
                    type: 'maxlength',
                    message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.VALID_THRU.MAX_LENGTH',
                    param: {
                        maxLength: 4,
                    },
                },
            ],
            cardCode: [
                { type: 'required', message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.CVV.REQUIRED' },
                {
                    type: 'minlength',
                    message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.CVV.MIN_LENGTH',
                    param: {
                        minLength: 3,
                    },
                },
                {
                    type: 'maxlength',
                    message: 'CARDS.CARD_MANAGER.CARDS_ACTIVE.FORM.CVV.MAX_LENGTH',
                    param: {
                        maxLength: 3,
                    },
                },
            ],
        };
    }
    getFormBasicInfo() {
        this.formBasicInfo = this.formBuilder.group({
            fullName: new FormControl('', Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(100)])),
            email: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(6),
                Validators.maxLength(60),
                Validators.pattern('[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,5}'),
            ])),
            bornDate: new FormControl('', Validators.compose([Validators.required])),
            phone: new FormControl('', Validators.compose([Validators.required, Validators.minLength(13), Validators.maxLength(14)])),
            document: new FormControl('', Validators.compose([Validators.required, Validators.minLength(14), DocumentValidator.isValidCPFCNPJ])),
        });
        return this.formBasicInfo;
    }
    getFormPaymentInfo() {
        this.formPaymentInfo = this.formBuilder.group({
            cardNumber: new FormControl('', Validators.compose([Validators.required, Validators.minLength(19), Validators.maxLength(19)])),
            cardName: new FormControl('', Validators.compose([Validators.required, Validators.minLength(6), Validators.maxLength(60)])),
            validDate: new FormControl('', Validators.compose([Validators.required, Validators.minLength(5), Validators.maxLength(5), validateDate])),
            cardCode: new FormControl('', Validators.compose([Validators.required, Validators.minLength(3), Validators.maxLength(3)])),
            flagCard: new FormControl('', Validators.compose([Validators.required])),
        });
        return this.formPaymentInfo;
    }
    getFormErrorBasicInfoErrorMessage() {
        return this.errorBasicInfoErrorMessage;
    }
    getFormPlanPaymentInfoErrorMessage() {
        return this.planPaymentInfoErrorMessage;
    }
};
PremiumInfosService.ctorParameters = () => [
    { type: FormBuilder },
    { type: Storage },
    { type: ConfigService }
];
PremiumInfosService = __decorate([
    Injectable()
], PremiumInfosService);
function validateDate(control) {
    let validThru = control.value;
    let arryDate = validThru.split('/');
    let currencyDate = new Date();
    const year = `20${arryDate[1]}`;
    if (Number(arryDate[0]) >= 1 && Number(arryDate[0]) <= 12) {
        if (Number(year) === currencyDate.getFullYear()) {
            if (Number(arryDate[0]) >= currencyDate.getMonth() + 1) {
                return null;
            }
            else {
                return { validThru: true };
            }
        }
        else if (Number(year) >= currencyDate.getFullYear()) {
            return null;
        }
        else {
            return { validThru: true };
        }
    }
    else
        return { validThru: true };
}

let QrcodeService = class QrcodeService extends BaseService {
    constructor(service, storage, configService) {
        super(storage, configService);
        this.service = service;
        this.storage = storage;
        this.configService = configService;
    }
    getDecodeQrCode(request) {
        return this.service.decodeQrcode(request);
    }
    getGenerateQrCode(request) {
        return this.service.generateQrcode(request);
    }
    getStatusQrCode(encode) {
        return this.service.statusQrcode(encode);
    }
};
QrcodeService.ctorParameters = () => [
    { type: SpeNAccountsProxy },
    { type: Storage },
    { type: ConfigService }
];
QrcodeService = __decorate([
    Injectable()
], QrcodeService);

let IndicatePartnerService = class IndicatePartnerService extends BaseService {
    constructor(formBuilder, storage, configService, serviceVouncherPartner) {
        super(storage, configService);
        this.formBuilder = formBuilder;
        this.storage = storage;
        this.configService = configService;
        this.serviceVouncherPartner = serviceVouncherPartner;
        this.errorIndicatePartnerErrorMessage = {
            company_name: [
                { type: 'required', message: 'NSC.INDICATE_NSC.MESSAGE.REQUIRED' },
            ],
            state: [
                { type: 'required', message: 'NSC.INDICATE_NSC.MESSAGE.REQUIRED' },
            ],
            city: [
                { type: 'required', message: 'NSC.INDICATE_NSC.MESSAGE.REQUIRED' },
            ],
            address: [
                { type: 'required', message: 'NSC.INDICATE_NSC.MESSAGE.REQUIRED' },
            ],
            site: [
                { type: 'required', message: 'NSC.INDICATE_NSC.MESSAGE.REQUIRED' },
            ],
            phone: [
                { type: 'minLength', message: 'NSC.INDICATE_NSC.MESSAGE.REQUIRED' },
            ],
        };
    }
    getFormIndicatePartner() {
        this.formIndicatePartnerInfo = this.formBuilder.group({
            company_name: new FormControl('', Validators.compose([
                Validators.required
            ])),
            state: new FormControl('', Validators.compose([
                Validators.required,
            ])),
            city: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(6),
                Validators.maxLength(100),
            ])),
            address: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(6),
                Validators.maxLength(100),
            ])),
            site: new FormControl('', Validators.compose([
                Validators.required,
            ])),
            phone: new FormControl('', Validators.compose([
                Validators.required,
                Validators.minLength(10),
                Validators.maxLength(14)
            ]))
        });
        return this.formIndicatePartnerInfo;
    }
    getFormErrorIndicatePartnerErrorMessage() {
        return this.errorIndicatePartnerErrorMessage;
    }
    indicatePartner(partner) {
        return this.serviceVouncherPartner.indicatePartner(partner);
    }
};
IndicatePartnerService.ctorParameters = () => [
    { type: FormBuilder },
    { type: Storage },
    { type: ConfigService },
    { type: SpeNVouncherClubNscProxy }
];
IndicatePartnerService = __decorate([
    Injectable()
], IndicatePartnerService);

let WalletService = class WalletService extends BaseService {
    constructor(storage, configService, speFelizProxy, errorMessageService, spenAccountsProxy, speViewNVouncherClubNscProxy, speNVouncherClubNscProxy) {
        super(storage, configService);
        this.storage = storage;
        this.configService = configService;
        this.speFelizProxy = speFelizProxy;
        this.errorMessageService = errorMessageService;
        this.spenAccountsProxy = spenAccountsProxy;
        this.speViewNVouncherClubNscProxy = speViewNVouncherClubNscProxy;
        this.speNVouncherClubNscProxy = speNVouncherClubNscProxy;
    }
    getWallets(uuidWhiteLabel, uuidAccount) {
        return __awaiter(this, void 0, void 0, function* () {
            let consultResponse;
            yield this.speFelizProxy.getWallets(uuidWhiteLabel, uuidAccount)
                .toPromise()
                .then(res => {
                consultResponse = res;
            })
                .catch(err => this.getError(err));
            let response = !!consultResponse ? consultResponse : null;
            return Promise.resolve(response);
        });
    }
    removeCard(uuidCard) {
        return this.spenAccountsProxy.deleteWalletCard(uuidCard);
    }
    getTransactions(uuidPayment) {
        return this.speViewNVouncherClubNscProxy.findTransactions(uuidPayment);
    }
    makeTransaction(payment) {
        return this.speNVouncherClubNscProxy.payment(payment);
    }
    /**
   * atualiza o qrcode
   * @param user
   */
    updateQrcode(user) {
        return this.speNVouncherClubNscProxy.updateQrcode(user);
    }
    getError(error) {
        this.errorMessageService.getError(error);
    }
};
WalletService.ctorParameters = () => [
    { type: Storage },
    { type: ConfigService },
    { type: SpeViewNAccountProxy },
    { type: ErrorMessageService },
    { type: SpeNAccountsProxy$1 },
    { type: SpeViewNVouncherClubNscProxy },
    { type: SpeNVouncherClubNscProxy }
];
WalletService = __decorate([
    Injectable()
], WalletService);

let PartnerService = class PartnerService {
    constructor(serviceVouncher, serviceAccount) {
        this.serviceVouncher = serviceVouncher;
        this.serviceAccount = serviceAccount;
    }
    findPartner(document) {
        return this.serviceVouncher.findPartner(document);
    }
    checkPartnerExists(uuidAccountPayment) {
        return this.serviceVouncher.checkPartnerExists(uuidAccountPayment);
    }
    applyPartner(partner) {
        return this.serviceAccount.applyPartner(partner);
    }
};
PartnerService.ctorParameters = () => [
    { type: SpeViewNVouncherClubNscProxy },
    { type: SpeNAccountsProxy }
];
PartnerService = __decorate([
    Injectable()
], PartnerService);

let UiBsNscModule = class UiBsNscModule {
};
UiBsNscModule = __decorate([
    NgModule({
        declarations: [],
        imports: [
            UiPxNscModule,
            UiBsTranslateModule,
            UiPxCashInModule,
            UiBsUtilModule
        ],
        providers: [
            SignUpService,
            PremiumInfosService,
            PartnerIndustryService,
            IndicatePartnerService,
            DashboardService,
            CardService,
            CategoryService,
            CouponService,
            WalletService,
            QrcodeService,
            PartnerService
        ],
    })
], UiBsNscModule);

/*
 * Public API Surface of ui-bs-nsc
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AddressType, BenefitEnum, CardService, CategoryService, CouponService, DashboardService, IndicatePartnerService, NscIndicatePartnerRequest, NscIndicatePartnerResponse, NscPremiumBasicInfoResponse, NscPremiumPaymentPlanResponse, NscRegisterResponse, NscSignupResponse, OrderStatusEnum, PartnerIndustryService, PartnerService, PremiumInfosService, QrcodeService, QrcodeType, SignUpService, StatusQrcode, TransactionType, UiBsNscModule, WalletService, validateDate };
//# sourceMappingURL=wlp-ui-bs-nsc.js.map
